import {LocalAuth} from "@/services/auth.service";
import {MsalAuth} from "@/services/msal.service";
import {countries as subsidiaries} from "@/utils/const";

function getInitialState() {
    const user = JSON.parse(localStorage.getItem("user"));

    return {
        status: {
            loggedIn: !!user,
            initialized: !!user
        },
        user: user,
        token: user?.accessToken || user?.idToken || null,
        provider: user?.accessToken ? "local" : user?.idToken ? "msal" : null,
        role: null,
        cons: null,
        // enabled: []
    }
}

function getProvider(provider) {
    if (provider === 'msal') { return MsalAuth; }
    if (provider === 'local') { return LocalAuth; }
    throw new Error(`Unknown auth provider: ${provider}`);
}

export const auth = {
    namespaced: true,
    state: getInitialState(),
    actions: {
        async initialize({commit}, { provider, client }) {
            if (provider !== "msal") return;

            await MsalAuth.initialize(client)
                .then((data) => {
                    this.user = data;
                    commit("initialize", data);
                    return Promise.resolve(data);
                })
                .catch((error) => {
                    commit("logout");
                    return Promise.reject(error);
                });
        },
        async login({commit}, { provider, credentials }) {
            // localStorage.clear();
            const service = getProvider(provider);

            try {
                const user = provider === "local"
                ? await service.login(credentials)
                : await service.login();

                commit("loginSuccess", {
                    user: user,
                    token: provider === "local" ? user.accessToken : user.idToken
                });

                commit("setProvider", provider);

                return user;
            } catch (error) {
                commit("loginFailure");
                throw error;
            }
        },

        async logout({ commit, state }) {
            const service = getProvider(state.provider);

            service.logout();
            commit("logout");
        },

        async token({ commit, state }) {
            const service = getProvider(state.provider);

            return state.provider === "msal"
                ? await service.getToken()
                    .then((token) => {
                        commit("tokenSuccess", token);
                        return Promise.resolve(token);
                    })
                    .catch((error) => {
                        commit("tokenFailure");
                        return Promise.reject(error);
                    })
                : null;
        },
        async role({ commit }) {
            try {
                const data = await LocalAuth.role();
                commit("setAuthContext", data);
                return data;
            } catch (error) {
                commit("authContextFailure");
                throw error;
            }
        },
    },
    mutations: {
        initialize(state, user) {
            state.status.initialized = true;
            state.user = user;
        },
        loginSuccess(state, { user, token = null}) {
            state.status.loggedIn = true;
            state.user = user;
            state.token = token;
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
            state.token = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;
            state.token = null;
            state.provider = null;
        },
        tokenSuccess(state, token) {
            state.status.loggedIn = true;
            state.token = token;
        },
        tokenFailure(state) {
            state.status.loggedIn = false;
            state.token = null;
        },
        setProvider(state, provider) {
            state.provider = provider;
        },
        setAuthContext(state, data) {
            state.role = data?.role;
            state.cons = data?.cons;
        },
        authContextFailure(state) {
            state.role = null;
            state.cons = null;
        }
    },
    getters: {
        loggedIn(state) {
            return (!!state.token && !!state.provider);
            // return state.status.loggedIn;
        },
        initialized(state) {
            return state.status.initialized;
        },
        user(state) {
            if (state.user) {
                return state.user;
            }
            return null;
        },
        name(state) {
            if (state.user) {
                return state.user.name;
            }
            return null;
        },
        username(state) {
            if (state.user) {
                return state.user.username;
            }
            return null;
        },
        token(state) {
            if (state.token) {
                return state.token;
            }
            return null;
        },
        provider(state) {
            if (state.provider) {
                return state.provider;
            }
            return null;
        },
        role: (state) => state.role,
        cons: (state) => state.cons,
        isAdmin: (state) => state.role === "admin" && state.cons === "all",
        isSubsidiaryUser: (state) => state.role === "user" && (subsidiaries.includes(state.cons)),
        isAbetUser: (state) => state.role === "user" && state.cons === "none",
        isSalesUser: (state) => state.role === "sales" && subsidiaries.includes(state.cons),
        isBaseUser: (state) => state.role === "sales" && state.cons === "none"
    },
};
